import { render, staticRenderFns } from "./ExtensionODCover.vue?vue&type=template&id=79cffba2"
import script from "./ExtensionODCover.vue?vue&type=script&lang=js"
export * from "./ExtensionODCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports